<script>
import { BSpinner } from "bootstrap-vue";

export default {
  extends: BSpinner
};
</script>